/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { PrintEntryPoint } from '@gh/common-shared-data';
import { entity, enumeration } from '@gh/core-data';
import { DocInfoDto } from './job-leters-docs.dto';

export const DocInfoMapper = entity<DocInfoDto>({
  entryPoint: enumeration(PrintEntryPoint),
});
